import {
  ViewerResponseModel, LayerDetailsModel, MapResponseModel, Sortorder, VersionResponseModel, FeatureModel, ConfigResponseModel,
  SearchResponseModel, AttachmentMetadataModel, BoundsModel,
} from '../models';
import { Observable } from 'rxjs';
import { FeaturesResponseModel } from '../models/features-response.model';
import { UniqueValuesResponseModel } from '../models/unique-values-response.model';
import { HttpResponse, HttpStatusCode } from '@angular/common/http';
import { LayerExtractResponseModel } from '../models/layer-extract-response.model';
import { LayerExtractCapabilitiesModel } from '../models/layer-extract-capabilities.model';

export interface TailormapApiV1ServiceModel {

  getVersion$(): Observable<VersionResponseModel>;

  getViewer$(id?: string): Observable<ViewerResponseModel>;

  getMap$(applicationId: string): Observable<MapResponseModel>;

  getDescribeLayer$(params: {
    applicationId: string;
    layerId: string;
  }): Observable<LayerDetailsModel>;

  getFeatures$(params: {
    applicationId: string;
    layerId: string;
    x?: number;
    y?: number;
    distance?: number;
    __fid?: string;
    simplify?: boolean;
    filter?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: Sortorder;
    onlyGeometries?: boolean;
    geometryInAttributes?: boolean;
    withAttachments?: boolean;
  }): Observable<FeaturesResponseModel>;

  deleteFeature$(params: {
    applicationId: string;
    layerId: string;
    fid: string;
  }): Observable<HttpStatusCode>;

  updateFeature$(params: {
    applicationId: string;
    layerId: string;
    feature: FeatureModel;
  }): Observable<FeatureModel>;

  createFeature$(params: {
    applicationId: string;
    layerId: string;
    feature: FeatureModel;
  }): Observable<FeatureModel>;

  getUniqueValues$(params: {
    applicationId: string;
    layerId: string;
    attribute: string;
    filter?: string;
  }): Observable<UniqueValuesResponseModel>;

  getLayerExtractFormats$(params: {
    applicationId: string;
    layerId: string;
  }): Observable<LayerExtractCapabilitiesModel>;

  requestLayerExtract$(params: {
    applicationId: string;
    layerId: string;
    clientId: string;
    outputFormat: string;
    attributes?: string[];
    filter?: string;
    sort: { column: string; direction: string} | null;
  }): Observable<LayerExtractResponseModel>;

  downloadLayerExtract$(params: {
    applicationId: string;
    layerId: string;
    downloadId: string;
  }): Observable<HttpResponse<Blob>>;

  retrieveZoomToExtentBounds$(params: {
    applicationId: string;
    layerId: string;
    filter?: string;
  }): Observable<BoundsModel>;

  getConfig$<T>(key: string): Observable<ConfigResponseModel<T>>;

  search$(params: {
    applicationId: string;
    layerId: string;
    query: string;
    start?: number;
  }): Observable<SearchResponseModel>;

  getLatestUpload$<T>(category: string): Observable<T>;

  addAttachment$(params: {
    applicationId: string;
    layerId: string;
    featureId: string;
    attribute: string;
    file: File;
    description: string | undefined;
  }): Observable<any>;

  listAttachments$(params: { applicationId: string; layerId: string; featureId: string }): Observable<AttachmentMetadataModel[]>;

  getAttachmentUrl(params: { applicationId: string; layerId: string; attachmentId: string }): string;

  deleteAttachment$(params: { applicationId: string; layerId: string; attachmentId: string }): any;
}
